// extracted by mini-css-extract-plugin
export default {"header":"Header_header__W4ryp","redirectButton":"Header_redirectButton__fQaoS"};